/**
 * 
 * key
 * 
 */


const key = 'ZW1haWw='

export default key 